var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDesktopEfectivo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 68.923,
    height: 64,
    viewBox: "0 0 68.923 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "desktop-efectivo",
    transform: "translate(-3 -2.992)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_31497",
    "data-name": "Trazado 31497",
    d: "M3,12.838a9.843,9.843,0,0,1,9.846-9.846H62.077V27.608a9.843,9.843,0,0,1-9.846,9.846H7.923v4.923H25.154a2.469,2.469,0,0,1,2.462,2.462V59.608a2.469,2.469,0,0,1-2.462,2.462H15.308a2.462,2.462,0,0,1,0-4.923h7.385V47.3H3ZM7.923,32.531H52.231a4.938,4.938,0,0,0,4.923-4.923V7.915H12.846a4.938,4.938,0,0,0-4.923,4.923Z",
    transform: "translate(0 0)",
    fill: "#00c1d4",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_31498",
    "data-name": "Trazado 31498",
    d: "M21.423,27.088A4.923,4.923,0,1,0,16.5,22.165,4.923,4.923,0,0,0,21.423,27.088Z",
    transform: "translate(30.808 32.519)",
    fill: "#00c1d4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_31499",
    "data-name": "Trazado 31499",
    d: "M51.385,19.915a4.938,4.938,0,0,0-4.923-4.923H16.923A4.938,4.938,0,0,0,12,19.915V34.684a4.938,4.938,0,0,0,4.923,4.923H46.462a4.938,4.938,0,0,0,4.923-4.923ZM21.846,34.684a4.938,4.938,0,0,0-4.923-4.923V24.838a4.938,4.938,0,0,0,4.923-4.923H41.538a4.938,4.938,0,0,0,4.923,4.923v4.923a4.938,4.938,0,0,0-4.923,4.923Z",
    transform: "translate(20.538 27.385)",
    fill: "#00c1d4",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesktopEfectivo);
export default __webpack_public_path__ + "static/media/desktop-efectivo.a8b3bc049664cbe4f3a2e0746a838222.svg";
export { ForwardRef as ReactComponent };